export default "__VITE_ASSET__YUc0x3mU__"